export default {"src":"/_next/static/media/Accept-icon-rounded.d61e6f41.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};